import { FormEvent, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { defaultRouteForRole } from './Login';

export function SetupPassword() {
  const { user, setupPassword, loading } = useAuth();
  const navigate = useNavigate();
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (loading) return <div className="auth-page">Lädt…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_reset_pw) return <Navigate to={defaultRouteForRole(user.role)} replace />;

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    if (pw1.length < 12) {
      setError('Mindestens 12 Zeichen.');
      return;
    }
    if (pw1 !== pw2) {
      setError('Passwörter stimmen nicht überein.');
      return;
    }
    setBusy(true);
    try {
      await setupPassword(pw1);
      navigate(defaultRouteForRole(user!.role), { replace: true });
    } catch {
      setError('Konnte Passwort nicht setzen.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page">
      <div className="auth-card">
        <img
          src="/tfc-logo-original.png"
          alt="THE FOODVENIENCE COMPANY"
          className="auth-brand-img"
        />
        <h1 className="auth-title auth-title--small">NEUES PASSWORT</h1>
        <p className="auth-claim">ERSTANMELDUNG · BITTE EIGENES PASSWORT VERGEBEN</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <label className="auth-field">
            <span className="auth-field__label">NEUES PASSWORT</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={12}
              value={pw1}
              onChange={(e) => setPw1(e.target.value)}
              className="auth-input"
              autoFocus
            />
          </label>

          <label className="auth-field">
            <span className="auth-field__label">BESTÄTIGEN</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={12}
              value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="auth-input"
            />
          </label>

          {error ? (
            <div className="auth-error" role="alert">
              {error}
            </div>
          ) : null}

          <button type="submit" disabled={busy} className="auth-submit">
            {busy ? 'WIRD GESETZT…' : 'PASSWORT SETZEN'}
          </button>
        </form>
      </div>
    </main>
  );
}
